
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"25","height":"25","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_3010_41680)","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M3.919 19.578h16.666c.92 0 1.667-.756 1.667-1.689V6.067c0-.933-.746-1.689-1.667-1.689H3.92c-.92 0-1.667.756-1.667 1.689v11.822c0 .933.746 1.69 1.667 1.69zM15.45 22.779h-6.4","stroke":"#fff"}}),_c('path',{attrs:{"d":"M15.45 11.778l-4.8-3.4v6.8l4.8-3.4z","stroke":"#EDC843"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_3010_41680"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(.25 .778)","d":"M0 0h24v24H0z"}})])])])
          )
        }
      }
    